// extracted by mini-css-extract-plugin
export default {"new_password_cont":"NewPassword_new_password_cont__fuQvV"};